import React, { useState, useCallback, useEffect } from "react";
import { useGetState } from "ahooks";
import { Tabs,  Spinner, Toast } from "@shopify/polaris";
import intl from "../../../../../i18n/intl";
import _ from "lodash";
// * 页面组件
// import message from "@/components/message";
import Product from "./components/Product";
import Description from "./components/Description";
import Variants from "./components/Variants";
import Media from "./components/Media";
// * api
// import { updateProductApi } from "@/api/modules/importList";
import {reqGetNewProductListInfo,reqPostDropshipmanNewProductAction} from '../../../../../api'
import { useMemo } from "react";
import { store } from "../../../../../store";
import { changeBannerData } from "../../../../../slice";
/**
 *
 * @param {Object} productInfo 产品详情
 * @returns
 */
const ProductInfo = ({ 
  recordKey, 
  productInfo, 
  onChange,
  currentSelected,
  productInfoData,
  productInfoSet,
  setChatData,
  chatData ,
  callResetPage,
  userPoints,
  setUserPoints
 }) => {
  const [selected, setSelected] = useState(0); // 当前Tab
  const [ruleData, setRuleData, getRuleData] = useGetState({
    Product:productInfo,
    Description:{},
    variants:{},
    Media:[],
  }); // 商品描述、变体、媒体图片详情
  // 模拟接口数据
  const [fakeObj, setFakeObj, getFakeObj] = useGetState({
    Requested: [],
  });
  let tabs = useMemo(()=>{
    let data = [
      { id: "Product", content: intl.get("Product") },
      { id: "Description", content: intl.get("Description") },
      {
        id: "Variants",
        content:intl.get("Variants") + "(" + productInfo?.variants_count + ")"
      },
      { id: "Media", content: intl.get("Media") },
    ]
    
    return data;
  },[productInfo]);
  // const tabs = useMemo(()=>[
  //   { id: intl.get("Product"), content: intl.get("Product") },
  //   { id: intl.get("Description"), content: intl.get("Description") },
  //   {
  //     id: "Variants",
  //     content:intl.get("Variants") + '(' + productInfo?.variants_count  + ')'
  //   },
  //   { id: "Media", content: intl.get("Media") },
  // ],[productInfo]);

  // // 各个字段对应接口的key值
  const actions = [
    {
      actionType: "title",
      field: "Title",
      valueKey: "ProductTitle",
    },
    {
      actionType: "collection",
      field: "SelectCollections",
      valueKey: "SelectCollectionsOptions",
      isToJSON: true,
    },
    {
      actionType: "tags",
      field: "SelectTags",
      valueKey: "SelectTagsOptions",
      isToJSON: true,
    },
    {
      actionType: "productType",
      field: "SelectProductType",
      valueKey: "SelectProductTypeOptions",
      isToJSON: true,
    },
    {
      actionType: "description",
      field: "Description",
      valueKey: "description",
    },
    {
      actionType: "variants",
      field: "Variants",
      valueKey: "variants",
      isToJSON: true,
    },
    {
      actionType: "images",
      field: "ProductImages",
      valueKey: "allImages",
      isToJSON: true,
    },
  ];
 
  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      setRuleData((prevValue)=>({
        ...prevValue,Product:productInfo
      }))
      setSelected(0)
      // setFakeObj([0])
        setFakeObj((prevValue)=>({
        ...prevValue,
        Requested:[]
      }))
     
    }
   return ()=>isMount = true
    // eslint-disable-next-line
  }, [currentSelected,productInfo]);

  // // 修改商品信息
  const updateProduct = async (type,filter) => {
    try {
    const ruleFormData = getRuleData(); // 获取最新值
    
    // // 判断是否有修改, 无修改则无需调接口
    if (!_.isEqual(productInfo, ruleFormData)) {
      // 找出当前修改的字段
      const action = _.find(actions, (item) => {
        return item.actionType === type;
      });

      let ProductList = ruleFormData.Product;
      switch (selected) {
        case 0:
          ProductList = ruleFormData.Product;
          break;
        case 1:
          ProductList = ruleFormData.Description;
          break;
        case 2:
          ProductList = ruleFormData.variants;
          break;
        case 3:
          ProductList = ruleFormData.Media;
          break;
        default:
          break;
      }

      if (action) {

        const params = {
          RecordId: getRuleData().Product.id, // 表单id
          actionType: action.actionType, // 需要更新的字段名（key）
          [action.valueKey]: action.isToJSON // 需要更新的字段值（value）
            ? JSON.stringify(ProductList[action.field])
            : ProductList[action.field],
        };
        // 调用更新接口
          const res = await reqPostDropshipmanNewProductAction(params);
          if (res && res.code === "200") {
            onChange(ruleFormData.Product); // 修改列表中的该条数据
            if (action.actionType === 'variants' && ProductList[action.field].length >= 100) {
              store.dispatch(changeBannerData({bannerData:{
                show:true,
                desc:intl.get('Shopify allows a maximum of 100 variants per product.')
              }}));
              let list = productInfoData.map((it) => {
                if (it.id === getRuleData().Product.id) {
                  return { ...it, productStatus: 1};
                } else {
                  return it;
                }
              });
               productInfoSet((prevValue)=>{
                  const params = prevValue.map((it,i)=>{
                    if (it.id === list[i].id) {
                      it.productStatus = list[i].productStatus
                      return it
                    }else{
                      return it
                    }
                  })
                  return params;
                });
             
            }else{
              if (filter === 'filter') {
                toggleToast('Filter applied')
              }else if (filter === 'modified') {
                toggleToast('Modified successfully')
              } else if (action.actionType === "title") {
                toggleToast('Saved successfully')
                let list = productInfoData.map((it) => {
                  if (it.id === getRuleData().Product.id && it.productStatus === 8) {
                    return { ...it, productStatus: 1};
                  } else {
                    return it;
                  }
                });
                 productInfoSet((prevValue)=>{
                    const params = prevValue.map((it,i)=>{
                      if (it.id === list[i].id ) {
                        it.productStatus = list[i].productStatus
                        return it
                      }else{
                        return it
                      }
                    })
                    return params;
                  });
              } else {
              toggleToast('Saved successfully')
              }
            }
          }else if (res.code === '301') {
            toggleToast('Modified successfully')
          } else{
            toggleToast('Error reminder')
          }
      }
    }
  } catch (error) {
          
  }
  };

  // 切换Tab
  const handleTabChange = useCallback((selectedTabIndex) => {
    setSelected(selectedTabIndex);
    // console.log(selectedTabIndex,getFakeObj()?.Requested);
    switch (selectedTabIndex) {
      case 0:
        break;
      case 1:
        if (getFakeObj()?.Requested?.indexOf(selectedTabIndex) === -1) {
          fakeRequest({ id: getRuleData().Product?.id,type:selectedTabIndex});
        }
       
        break;
      case 2:
        if (getFakeObj()?.Requested?.indexOf(selectedTabIndex) === -1) {
          fakeRequest({ id: getRuleData().Product?.id,type:selectedTabIndex });
        }
        break;
      case 3:
        if (getFakeObj()?.Requested?.indexOf(selectedTabIndex) === -1) {
          fakeRequest({ id: getRuleData().Product?.id,type:selectedTabIndex });
        }
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadingComponent = useCallback((key, component) => {
    return key > 0 ? (
        component
    ) : (
      <div style={{ textAlign: "center" }}>
        <Spinner accessibilityLabel="Spinner" size="large" />
      </div>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFakeObj()]);

  // 模拟接口请求
  const fakeRequest = async ({id,type}) => {
        try {
        
        let res = await reqGetNewProductListInfo({dsm_product_id:id,type});
        if (res.code === '200') {
          switch (type) {
            case 1:
              setRuleData((prevValue)=>({
                ...prevValue,
                Description:res.data
              }))
              break;
          
            case 2:
              setRuleData((prevValue)=>({
                ...prevValue,
                variants:res.data
              }))
              break;
            case 3:
              setRuleData((prevValue)=>({
                ...prevValue,
                Media:res.data
              }))
              break;
              
            default:
              break;
          }
        }
       
        let requested = _.cloneDeep(getFakeObj()?.Requested);
        requested.push(type);
        requested = Array.from(new Set(requested));
        setFakeObj((prevValue) => ({
          ...prevValue,
          Requested: requested,
        }));
       
      } catch (error) {
          console.log(fakeObj);
      }
  };

  const [showToast, setShowToast] = useState(false);
    const [showToastText, setShowToastText] = useState("");
    const [showToastIserror, setShowToastIserror] = useState(false);
     //提示弹窗
     const toggleToast = (showToastText, showToastIserror = false) => {
        setShowToast(!showToast);
        setShowToastText(showToastText);
        setShowToastIserror(showToastIserror);
      };
  
      const toastMarkup = showToast ? (
        <Toast
          content={showToastText}
          onDismiss={() => toggleToast("")}
          error={showToastIserror}
          duration={2000}
        />
      ) : null;
  return (
    <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange}>
         
        {/* 产品详情 */}
        {selected === 0 && (
          <Product
            setChatData={setChatData}
            chatData={chatData}
            data={Object.values(ruleData).length > 0 ? ruleData?.Product : {}}
            setRuleForm={setRuleData}
            onSave={updateProduct}
            callResetPage={callResetPage}
            userPoints={userPoints}
            setUserPoints={setUserPoints}
          />
        )}
        {/* 产品描述 */}
        {selected === 1 &&
          loadingComponent(
            1,
            <Description
              setChatData={setChatData}
              chatData={chatData}
              id={productInfo.id}
              data={ruleData.Description}
              productData={Object.values(ruleData).length > 0 ? ruleData?.Product : {}}
              setRuleForm={setRuleData}
              onSave={updateProduct}
              userPoints={userPoints}
              setUserPoints={setUserPoints}
            />
          )}
        {/* 变体信息 */}
        {selected === 2 &&
          loadingComponent(
            2,
            <Variants
              id={productInfo.id}
              recordKey={recordKey}
              productInfoData={productInfoData}
              productInfoSet={productInfoSet}
              data={Object.values(ruleData.variants).length >0 ? getRuleData()?.variants : {}}
              setRuleForm={setRuleData}
              onSave={updateProduct}
            />
          )}
        {/* 产品图片 */}
        {selected === 3 &&
          loadingComponent(
            3,
            <Media
              data={ruleData.Media}
              title={productInfo?.Title}
              setRuleForm={setRuleData}
              onSave={updateProduct}
            />
          )}
         
      {/* 提示弹窗 */}
      {toastMarkup}
     
    </Tabs>
  );
};

export default ProductInfo;
